import * as React from 'react';

import { IProfileMenuProps, IProfileMenuState } from './ProfileMenu-types';

import './ProfileMenu.scss';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { ExitToAppOutlined } from '@mui/icons-material';
import { analytics } from './ProfileMenu-analytics';
import { Avatar } from '@thought-river/ui-components';

@analytics()
export default class ProfileMenu extends React.Component<
    IProfileMenuProps,
    IProfileMenuState
> {
    private readonly profileRef: React.RefObject<HTMLDivElement>;

    constructor(props: IProfileMenuProps) {
        super(props);

        const user = this.props.users.find(
            (user) => user.id === this.props.userId
        );

        this.state = {
            open: false,
            anchorElement: null!, // Fixme: null checks
            email: user?.email ?? '',
            fullName: user ? `${user.firstName} ${user.lastName}` : '',
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);

        this.profileRef = React.createRef();
    }

    private handleClose() {
        this.setState({
            anchorElement: null!, // Fixme: null checks
            open: false,
        });
    }

    private handleOpen() {
        this.setState({
            anchorElement: this.profileRef.current!, // Fixme: null checks
            open: true,
        });
    }

    private onSignOut() {
        this.props.setLogout(true);
    }

    render() {
        const { anchorElement, email, fullName, open } = this.state;
        const { accountCode } = this.props;

        return (
            <React.Fragment>
                <div
                    className="profile-menu-anchor header-menu-anchor"
                    onClick={this.handleOpen}
                    ref={this.profileRef}
                    id="user-button"
                >
                    <Avatar label={fullName} size="medium" />
                </div>
                <Menu
                    className="profile-menu"
                    anchorEl={anchorElement}
                    open={open}
                    onClose={this.handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'user-button',
                    }}
                >
                    <MenuItem
                        className="menu-item profile-info"
                        key={'profile-info'}
                    >
                        <span className="user-info-wrapper">
                            <Avatar label={fullName} size="large" />
                            <div className="user-info-details">
                                <div className="user-name">{fullName}</div>
                                <div className="user-email">{email}</div>
                                <div className="user-account">
                                    {accountCode}
                                </div>
                            </div>
                        </span>
                    </MenuItem>
                    <MenuItem
                        className="menu-item sign-out"
                        onClick={() => {
                            this.handleClose();
                            this.onSignOut();
                        }}
                        key={'profile-sign-out'}
                    >
                        <ListItemIcon className="menu-item-icon">
                            <ExitToAppOutlined />
                        </ListItemIcon>
                        <ListItemText
                            className="menu-item-label"
                            primary="Sign out"
                        />
                    </MenuItem>
                </Menu>
            </React.Fragment>
        );
    }
}
